import React from 'react'
import classNames from 'classnames'
import { node, string, object, array, oneOfType } from 'prop-types'

const ListItem = ({ children, className }) => (
  <li className={classNames('sw-list-item', className)}>{children}</li>
)

ListItem.displayName = 'ListItem'

ListItem.propTypes = {
  /** Component's children */
  children: node,
  /** Custom className */
  className: oneOfType([string, object, array])
}

export default ListItem
